import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { HeroType } from '../../types';

interface HeroInfoBoxProps {
  heroType: HeroType;
}

export function HeroInfoBox({ heroType }: HeroInfoBoxProps) {
  return (
    <Box
      sx={{
        flex: 1,
        bgcolor: 'grey.50',
        borderRadius: 3,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        alignSelf: 'flex-start',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        <InfoOutlinedIcon sx={{ color: 'info.main', fontSize: 20, mt: 0.25 }} />
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <strong>Hero-innehållet</strong> visas högst upp på startsidan i Play-sektionen och är
            det första användarna ser.
          </Typography>
          {heroType === 'image' ? (
            <Typography variant="body2" color="text.secondary">
              <strong>Bild:</strong> Rekommenderad storlek är 1920x1080 pixlar för bästa visning på
              alla enheter. Använd en högupplöst bild för bästa resultat.
            </Typography>
          ) : (
            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                <strong>Video:</strong> Videon spelas upp i en loop utan ljud. Användaren kan klicka
                för att öppna hela videon.
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                <strong>Loop-intervall:</strong> Välj vilken del av videon som ska loopa. Håll
                loopen kort (5-15 sekunder) för bästa upplevelse.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Förhandsgranska:</strong> Klicka på play-knappen för att se hur loopen
                kommer att se ut. Videon spelas automatiskt inom det valda intervallet.
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
